var _defs, _style, _use, _use2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 50",
    width: 90,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 90,
    height: 50,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAAAyAQMAAADmwV52AAAAAXNSR0IB2cksfwAAAANQTFRF////p8QbyAAAAA9JREFUeJxjYBgFo2AwAAACigABxXWI+QAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 153,
    height: 110,
    id: "img2",
    href: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyLjExNjc2aW4iIGhlaWdodD0iMS41aW4iIHZpZXdCb3g9IjAgMCAxNTIuNDA3IDEwOCI+DQogIDxnPg0KICAgIDxyZWN0IHdpZHRoPSIxNTIuNDA3IiBoZWlnaHQ9IjEwOCIgc3R5bGU9ImZpbGw6IG5vbmUiLz4NCiAgICA8Zz4NCiAgICAgIDxyZWN0IHg9IjYwLjQxMTciIHk9IjI1LjY5NjgiIHdpZHRoPSIzMS41IiBoZWlnaHQ9IjU2LjYwNjQiIHN0eWxlPSJmaWxsOiAjZmY1ZjAwIi8+DQogICAgICA8cGF0aCBkPSJNMzgyLjIwODM5LDMwNmEzNS45Mzc1LDM1LjkzNzUsMCwwLDEsMTMuNzQ5OS0yOC4zMDMyLDM2LDM2LDAsMSwwLDAsNTYuNjA2NEEzNS45MzgsMzUuOTM4LDAsMCwxLDM4Mi4yMDgzOSwzMDZaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzE5Ljc5NjQ5IC0yNTIpIiBzdHlsZT0iZmlsbDogI2ViMDAxYiIvPg0KICAgICAgPHBhdGggZD0iTTQ1NC4yMDM0OSwzMDZhMzUuOTk4NjcsMzUuOTk4NjcsMCwwLDEtNTguMjQ1MiwyOC4zMDMyLDM2LjAwNTE4LDM2LjAwNTE4LDAsMCwwLDAtNTYuNjA2NEEzNS45OTg2NywzNS45OTg2NywwLDAsMSw0NTQuMjAzNDksMzA2WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMxOS43OTY0OSAtMjUyKSIgc3R5bGU9ImZpbGw6ICNmNzllMWIiLz4NCiAgICAgIDxwYXRoIGQ9Ik00NTAuNzY4ODksMzI4LjMwNzd2LTEuMTU4OWguNDY3M3YtLjIzNjFoLTEuMTkwMXYuMjM2MWguNDY3NXYxLjE1ODlabTIuMzEwNSwwdi0xLjM5NzNoLS4zNjQ4bC0uNDE5NTkuOTYxMS0uNDE5NzEtLjk2MTFoLS4zNjV2MS4zOTczaC4yNTc2di0xLjA1NGwuMzkzNS45MDg3aC4yNjcxbC4zOTM1MS0uOTExdjEuMDU2M1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMTkuNzk2NDkgLTI1MikiIHN0eWxlPSJmaWxsOiAjZjc5ZTFiIi8+DQogICAgPC9nPg0KICA8L2c+DQo8L3N2Zz4NCg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#img2",
    transform: "matrix(.455,0,0,.455,10,-1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.f18d0048e51544aa234a5e1ca01b9b6b.svg";
export { ForwardRef as ReactComponent };